export default __webpack_public_path__ + "static/certificates-results-1-7532171082a5f20914141d7d4d9f19e5.png";